import { jetbrainsMono } from '@/theme/utils/font.utils';

export {
  PAGE_DATA_NUMBER_CLASS as AIFI_DATA_NUMBER_CLASS,
  PAGE_DATA_NUMBER_INLINE_CSS as AIFI_DATA_NUMBER_INLINE_CSS,
} from '@/domains/pages/shared/typography';

/** Canvas / Chart.js `font.family` for axis ticks and labels. */
export const AIFI_CHART_FONT_FAMILY = jetbrainsMono.style.fontFamily;

/** Platform font for inline HTML (email preview, external tooltips). */
export const AIFI_FONT_FAMILY = jetbrainsMono.style.fontFamily;

/** Shared Chart.js axis tick font. */
export const AIFI_CHART_TICK_FONT = { size: 11, family: AIFI_CHART_FONT_FAMILY } as const;
